var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import LocalDb from '../model/local-db';
import Api from '../model/api';
import { decorator } from '../utils/instance';
import Emitter from '../utils/emitter';
var User = (function (_super) {
    __extends(User, _super);
    function User(config) {
        var _this = _super.call(this) || this;
        _this.config = config;
        _this._api = Api.getInstance(config);
        _this._db = new LocalDb("im-sdk-user-" + config.region + "-" + config.channel);
        _this._data = _this._db.get() || {};
        return _this;
    }
    User.prototype.getLoginInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = this.config;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this._api.request(config._url.getLoginUserInfo, {
                                accessKey: config.accessKey,
                                accessToken: config.accessToken,
                            })];
                    case 2:
                        data = _a.sent();
                        this.loginUser = data;
                        this._saveData(this.parseData(data));
                        return [2, Promise.resolve(data)];
                    case 3:
                        err_1 = _a.sent();
                        console.log('API Error', err_1);
                        return [2, Promise.reject(err_1)];
                    case 4: return [2];
                }
            });
        });
    };
    User.prototype.getUsers = function (users) {
        var _this = this;
        var config = this.config;
        var requestUsers = users.filter(function (user) {
            var userListByType = _this._data[user.userType];
            return (user.userId && user.userId !== 'null' && user.userId !== null) && user.userType && (!userListByType || !userListByType[user.userId]);
        });
        if (requestUsers.length) {
            var parts = [];
            while (requestUsers.length > 0) {
                parts.push(requestUsers.splice(0, 50));
            }
            var promises = parts.map(function (part) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this._api.request(config._url.getUserInfo, {
                                accessKey: config.accessKey,
                                accessToken: config.accessToken,
                                userAccountQueryJSONString: JSON.stringify(part),
                            }, {
                                type: 'POST',
                                dataType: 'json',
                            })];
                        case 1:
                            data = _a.sent();
                            if (data.result) {
                                data = data.result;
                            }
                            if (!Array.isArray(data)) {
                                data = [];
                            }
                            this._saveData(data.map(this.parseData, this));
                            return [2, Promise.resolve()];
                    }
                });
            }); });
            return Promise.all(promises);
        }
        return Promise.resolve();
    };
    User.prototype.getUserData = function (userType, userId) {
        userType = parseInt(userType);
        var userListByType = this._data[userType] || {};
        return userListByType[userId] || {
            headUrl: this.config.userDefaultHeadMap[userType] || '',
            nickName: '',
            userId: userId,
            userType: userType,
        };
    };
    User.prototype._saveData = function (dataList) {
        var e_1, _a;
        if (!Array.isArray(dataList)) {
            dataList = [dataList];
        }
        try {
            for (var dataList_1 = __values(dataList), dataList_1_1 = dataList_1.next(); !dataList_1_1.done; dataList_1_1 = dataList_1.next()) {
                var userData = dataList_1_1.value;
                var userListByType = this._data[userData.userType];
                if (!userListByType) {
                    userListByType = this._data[userData.userType] = {};
                }
                userListByType[userData.userId] = userData;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (dataList_1_1 && !dataList_1_1.done && (_a = dataList_1.return)) _a.call(dataList_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this._db.save(this._data);
    };
    User.prototype.parseData = function (data) {
        var userData = data.data || {};
        var headUrl = userData.headUrl || this.config.userDefaultHeadMap[data.userType] || '';
        if (typeof userData.translationAgreement === 'string') {
            userData.translationAgreement = userData.translationAgreement === 'true';
        }
        if (typeof userData.translationDisable === 'string') {
            userData.translationDisable = userData.translationDisable === 'true';
        }
        if (typeof userData.translationOn === 'string') {
            userData.translationOn = userData.translationOn === 'true';
        }
        return {
            headUrl: headUrl,
            nickName: userData.nickName || '',
            userId: data.userId,
            userType: parseInt(data.userType),
            data: userData,
        };
    };
    User = __decorate([
        decorator
    ], User);
    return User;
}(Emitter));
export default User;
